import classnames from 'classnames'
import React from 'react'

import styles from './FieldError.module.scss'

type FieldErrorProps = {
  touched?: boolean
  error?: string
  omitErrorDisplay?: boolean
} & React.HTMLAttributes<HTMLDivElement>

export default React.memo(function FieldError({
  touched,
  error,
  omitErrorDisplay,
  className,
  ...htmlProps
}: FieldErrorProps) {
  return omitErrorDisplay ? null : (
    <div className={classnames(styles.FieldError, className)} {...htmlProps}>
      {touched && error}
    </div>
  )
})
